import styled from "styled-components";
import { Link } from "gatsby";
import { calculateResponsiveSize } from "helpers/calculateResponsiveSize";
import { mediaMax } from "helpers/mediaQueries";

export const ImageWrapper = styled.div`
  width: 60%;
  padding: 0;
  ${mediaMax("tabletLandscape")} {
    padding: 0 20px;
    width: 100%;
  }
`;

export const InfoContent = styled.div`
  ${mediaMax("desktopSm")} {
    h3 {
      white-space: pre-wrap;
    }
  }
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 40%;
  justify-content: center;
  /* align-items: center; */
  padding: 0 0 0 ${calculateResponsiveSize(215)};
  ${mediaMax("tabletLandscape")} {
    padding: 24px 20px 48px;
    width: 100%;
  }
`;

export const Plantem = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  background-color: #e7e4d5;
  padding: ${calculateResponsiveSize(120)} 0;
  &.park-section {
    padding-top: 0;
  }
  &.park-section {
    ${ImageWrapper} {
      padding-right: 0;
    }
  }
  ${mediaMax("tabletLandscape")} {
    padding: 0;
    flex-direction: column-reverse;
  }
  &.park-section {
    ${ImageWrapper} {
      padding: 0;
    }
  }
`;
